export enum ContingentType {
  Paid,
  Free,
}
